const AudioPlaceholder = () => {
  const bars = Array.from({ length: 6 });
  return (
    <div
      style={{
        display: 'flex',
        gap: '3px',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {bars.map((_, index) => (
        <div
          key={index}
          style={{
            width: '2px',
            height: '4px',
            borderRadius: '1px',
            backgroundColor: '#C77AC4',
          }}
        />
      ))}
    </div>
  );
};
export default AudioPlaceholder;
